import { http } from "./http";
import {
  getAdminScope,
  scopedSchoolName,
  filterSchoolRows
} from "@/utils/adminScope";

// /**
//  * 디바이스 생성
//  */
// export async function addDevice(device) {
//   try {
//     const body = {
//       device_uuid: device.uuid,
//       name: device.name,
//       group_id: device.group_id,
//       status: "OFFLINE"
//     };
//     const res = await http.post(`/device`, body);
//     if (res.data.code === 1) {
//       return true;
//     } else {
//       return false;
//     }
//   } catch (error) {
//     console.error("디바이스 생성: ", error);
//     throw error;
//   }
// }

// // 그룹 내 디바이스 조회
// export async function getGroupDevice(group_id) {
//   try {
//     const res = await http.get(`/device/group/${group_id}`);
//     if (res.data.code === 1) {
//       return res.data.device_group_list;
//     } else {
//       return [];
//     }
//   } catch (error) {
//     console.error("그룹 조회: ", error);
//     throw error;
//   }
// }

// // 디바이스 전체 조회
// export async function getGroupDeviceAll() {
//   try {
//     const res = await http.get(`/device/all`);
//     if (res.data.code === 1) {
//       return res.data.device_group_list;
//     } else {
//       return [];
//     }
//   } catch (error) {
//     console.error("그룹 조회: ", error);
//     throw error;
//   }
// }

// // 디바이스 수정
// export async function updateDevice(device) {
//   try {
//     const body = {
//       device_uuid: device.uuid,
//       name: device.name,
//       group_id: device.group_id,
//       status: device.status
//     };
//     const res = await http.put(`/device`, body);
//     if (res.data.code === 1) {
//       return true;
//     } else {
//       return false;
//     }
//   } catch (error) {
//     console.error("디바이스 생성: ", error);
//     throw error;
//   }
// }

// // 디바이스 삭제
// export async function removeDevice(uuid) {
//   try {
//     const res = await http.delete(`/device/${uuid}`);
//     if (res.data.code === 1) {
//       return true;
//     } else {
//       return false;
//     }
//   } catch (error) {
//     console.error("그룹 삭제: ", error);
//     throw error;
//   }
// }

// 디바이스 전체 조회
export async function getDevice(uuid, school_name) {
  try {
    const res = await http.get(`/device`, {
      params: {
        uuid,
        school_name: scopedSchoolName(school_name)
      }
    });

    if (res.data.code === 1) {
      return filterSchoolRows(res.data.device_list);
    } else {
      return [];
    }
  } catch (error) {
    console.error("디바이스 조회: ", error);
    throw error;
  }
}

// Header notifications have their own endpoint; failure must not become an empty list.
export async function getDevice24({ signal } = {}) {
  const res = await http.get("/device24", {
    params: { school_name: scopedSchoolName() },
    signal
  });
  if (res.data?.code !== 1 || !Array.isArray(res.data.device_list)) {
    throw new Error("초과사용 알림 응답을 확인할 수 없습니다.");
  }
  return filterSchoolRows(res.data.device_list);
}

export async function getDevice2(uuid, school_name) {
  try {
    const res = await http.get(`/device/ALL`, {
      params: {
        uuid,
        school_name: scopedSchoolName(school_name)
      }
    });

    if (res.data.code === 1) {
      return filterSchoolRows(res.data.device_list);
    } else {
      return [];
    }
  } catch (error) {
    console.error("디바이스 조회: ", error);
    throw error;
  }
}

// 디바이스 정보 수정
export async function updateDevice({
  device_uuid,
  school_id,
  app_location,
  base_usage_sec
}) {
  if (getAdminScope().restricted) {
    const device = await assertDeviceInScope(device_uuid);
    if (String(device.school_id ?? device.school_idx) !== String(school_id)) {
      throw new Error("담당 학교 밖으로 기기를 이동할 수 없습니다.");
    }
  }
  try {
    const res = await http.put(`/device`, {
      device_uuid,
      school_id,
      app_location,
      base_usage_sec
    });

    return res.data.code === 1;
  } catch (error) {
    console.error("디바이스 정보 수정: ", error);
    throw error;
  }
}

// 디바이스 사용시간 조회
export async function getDeviceUse(uuid, start_date, end_date) {
  await assertDeviceInScope(uuid);
  try {
    const res = await http.get(`/device/use`, {
      params: {
        device_uuid: uuid,
        startDate: start_date,
        endDate: end_date
      }
    });

    if (res.data.code === 1) {
      return res.data.device_use_log;
    } else {
      return [];
    }
  } catch (error) {
    console.error("그룹 삭제: ", error);
    throw error;
  }
}

// 디바이스 월별 사용시간 조회
export async function getDeviceUseMonth(uuid, start_month, end_month) {
  await assertDeviceInScope(uuid);
  try {
    const res = await http.get(`/device/use/month`, {
      params: {
        device_uuid: uuid,
        startDate: start_month,
        endDate: end_month
      }
    });

    if (res.data.code === 1) {
      return res.data.device_use_log;
    } else {
      return [];
    }
  } catch (error) {
    console.error("그룹 삭제: ", error);
    throw error;
  }
}

// 상세 API는 학교 조건이 없으므로 학교 제한 목록에서 UUID를 재확인한다.
async function assertDeviceInScope(uuid) {
  if (!getAdminScope().restricted) return;
  if (!uuid) throw new Error("조회할 기기가 없습니다.");
  const rows = await getDevice(uuid);
  const device = rows.find((row) => row.device_uuid === uuid);
  if (!device) {
    throw new Error("담당 학교의 기기만 조회할 수 있습니다.");
  }
  return device;
}
